// 配置文件
let platform = process.env.VUE_APP_PLATFORM;
let prod = process.env.NODE_ENV === 'production';
export const $appid = "1"
let apiurl = prod ? '' : 'http://127.0.0.1:8080';
// export const $apiurl = prod? '': 'http://172.16.1.155:8081';
// export const $apiurl = '';
if (window.location.hostname == 'www.huaeb.com' || window.location.hostname.indexOf('.cloudfront.net') >= 0)
	apiurl = '/int';
export const $apiurl = apiurl;
export const $wxatag = 'webpc';
export const $sysName = 'HUAEB INTERNATIONAL';
export const $version = '1.0.0';
export const $LANGTAB = window.localStorage.LANGTAB ? JSON.parse(window.localStorage.LANGTAB) : {
	lang: 'zh_CN',
	time: 0,
	table: {
		// $t("扫一扫"):'scan'
	}
};
export default {
	install(Vue) {
		Vue.prototype.$logow = "https://cdn-qn.xqbc365.com/v2/20201127/Fs8OzPKVk4Ge9IwAu9ZZ3aOsLmJr.jpeg"
		Vue.prototype.$logo = "https://cdn-qn.huaeb.com/sellmall/20210126/FhgMrmAGxOpS8Yc7Bizvb3Gkqerx.png"
		Vue.prototype.$sysName = $sysName
		Vue.prototype.$appid = $appid
		Vue.prototype.$version = $version
		Vue.prototype.$apiurl = $apiurl
	}
}
